import ConciliacaoBancariaLista from "@/modules/ConciliacaoBancaria/pages/Index";
import ConciliacaoBancariaNova from "@/modules/ConciliacaoBancaria/pages/Create";

export default [
  {
    name: "conciliacaoBancariaLista",
    path: "/conciliacao-bancaria",
    component: ConciliacaoBancariaLista,
    meta: { title: "Conciliação Bancária" },
  },
  {
    name: "conciliacaoBancariaNova",
    path: "/conciliacao-bancaria/nova",
    component: ConciliacaoBancariaNova,
    meta: { title: "Nova Conciliação Bancária" },
  },
  {
    name: "conciliacaoBancariaDetalhe",
    path: "/conciliacao-bancaria/:id/detalhe",
    component: ConciliacaoBancariaNova,
    meta: { title: "Detalhe da Conciliação" },
  },
];
